// name of fields in CreationWizard root component state
export default {
	selectedAppId: { type: Number },
	selectedPlacementId: { type: Number },
};
